module.exports = __webpack_public_path__ + "static/MakanHati-f1c06c17f521a2803590035f95e0f88a.ttf";